import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { IMobileAppStore } from '../types';
import { Tabs } from '../../modules/mobile/exports/Enums';
import collect from 'collect.js';

export default createSlice({
  name: REDUX_STORE_SLICES.MOBILE_APP,
  initialState: {
    pushNotificationsStatus: null,
    pushNotificationPopup: {},
    sessions: [],
    appReviewRequested: false,
  },
  reducers: {
    update: (state: IMobileAppStore, action: PayloadAction<Partial<IMobileAppStore>>) => {
      Object.assign(state, action.payload);
    },
    presentedPushNotificationPopup: (state, action: PayloadAction<{ tab: Tabs }>) => {
      const { tab } = action.payload;
      const prevAskedAt = state.pushNotificationPopup[tab]?.askedAt ?? [];
      const newAskedAt = [...prevAskedAt, new Date().toISOString()].slice(-3);

      state.pushNotificationPopup = {
        ...state.pushNotificationPopup,
        [tab]: {
          askedAt: newAskedAt,
          session: collect(state.sessions).last(),
        },
      };
    },
    addSession: (state, action: PayloadAction<string>) => {
      state.sessions = collect([...state.sessions, action.payload])
        .slice(-3)
        .toArray();
    },
  },
});

export const props = (state: IMobileAppStore) => state;
